/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Link from './Link/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/App/Widget/Content/Questions/Complete/MedicalForm/Content/MedicalFormUrl/Content/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Link'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Link'}>
<Link
  viewPath={`${viewPath}/Link`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}